<template lang="pug">
v-content.black  
  v-dialog(v-model="news_dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
    gallery(:images="c_images" :index="index" @close="index = null" :options="{ closeOnSlideClick: true }")
    v-toolbar(absolute dense)
      v-btn(icon @click="news_dialog = false")
        v-icon mdi-close
    v-card.pt-10
      v-container(v-if="c_n" fluid)
        v-row(justify="center")
          v-col(cols=12 md=5)
            v-card(hover @click="index = 0")
              v-img(:src="require(`@/assets/news/${c_n.id}/1.jpg`)" contain)
          v-col(cols=12 md=7)
            v-card(flat)
              h1.display-1.py-5.text-center {{ c_n.name }}
              v-card-text.body-1 {{ c_n.text }}
              v-row(justify="center")
                v-col(cols=5 v-for="i in c_n.images" :key="i")
                  v-card(hover @click="index = i")
                    v-img(:src="require(`@/assets/news/${c_n.id}/${i+1}.jpg`)" contain)

  section#hero    
    v-container.pa-0(fluid)
      v-row(no-gutters)
        v-col(cols=12)
          v-img(src="../assets/full.jpg" aspect-ratio=1.7777)
            canvas#custom-canvas(width=1920 height=1080)

  section#news.primary
    v-container(fluid)
      v-row.text-center.pb-5
        v-col(cols=12)
          h1.display-2.font-weight-bold.black--text Новости
      v-row(justify="center")
        v-col(cols=12 md=12 lg=12 xl=10)
          v-row(justify="center" dense)
            v-col(cols=12 sm=6 md=3 v-for="n in news" :key="n.id")
              v-card(hover @click="c_n=n; news_dialog=true")
                v-img.align-end(:src="require(`@/assets/news/${n.id}/0.jpg`)" aspect-ratio=0.8 gradient="to top, rgba(0, 0, 0, 0.8), transparent 100px")
                  v-card-title.title {{ n.name }}
                  
  section#map
    yandex-map(:coords="coords" :scroll-zoom="false")
      ymap-marker(:coords="coords" marker-id="123")
      
  v-footer.primary(light)
    v-col(cols=12).text-center
      v-btn(text href="https://vk.com/id135363594" target="_blank")
        v-icon.pr-1(x-large) mdi-vk
        span Спиридонова Аэлита
</template>

<style lang="stylus">
#hero
  margin-bottom 150px

#map
  margin-top 150px
  margin-bottom 150px

#news
  padding-bottom 50px

  .title
    word-break normal

.ymap-container
  height 600px

#custom-canvas
  height 100%
  width 100%
</style>

<script>
import VueGallery from 'vue-gallery'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default {
  name: 'Home',
  data() {
    return {
      news_dialog: false,
      c_n: null,
      index: null,
      coords: [52.60165, 39.516144],
      news: [
        {
          id: 1,
          images: 2,
          name: 'Блокадный хлеб',
          text: `С 18 по 27 января во всех регионах нашей страны проводится
Всероссийская Акция памяти «Блокадный хлеб», которая дает старт
Году памяти и славы. Акция призвана напомнить о мужестве жителей
Ленинграда, переживших беспрецедентную блокаду миллионного города
вражескими захватчиками. Блокадный хлеб… Муки в нем было не намного
больше, чем жмыха, целлюлозы, соды, отрубей. Форму для выпечки которого
смазывали за неимением другого соляровым маслом. Есть который можно
было, как говорили сами блокадники, «только запивая водой и с молитвой»..
Но и сейчас нет для них ничего дороже него.
27 января 2020 года преподаватель ДДТ «Лира» Спиридонова А.Р
объединение «Шаг на сцену» провел для учащихся урок ,посвященный
снятию советскими войсками блокады великого города Ленинграда . Для
ребят был подготовлен видеоролик, из которого они узнали о том, что
блокада Ленинграда длилась 872 дня. Были розданы небольшие кусочки
черного хлеба, напоминающего тот, блокадный паек. Мы никогда не сможем
почувствовать ужасы тех лет, потому что это было не с нами. Но пока мы
помним о ленинградцах – они живы в наших сердцах!`
        },
        {
          id: 2,
          images: 1,
          name: 'Фестиваль басен',
          text: `Театр – это не просто игра, театр – чудесное средство развития детей.
Благодаря вовлечению детей в мир театра и искусства происходит их
знакомство с музыкальной, литературной и театральной культурной.
Театрализация – не просто развлечение, но и отличное средство для развития
уникальной, неповторимой личности ребенка и его творческого потенциала.
6 декабря, 2019 года школе №65 состоялось "Открытие Фестиваля басни".
Учащиеся проявили талант и мастерство в сфере театрального искусства
Басни: "Квартет", "Мартышка и очки", "Стрекоза и муравей", «Волк и
ягненок», «Ворона и лисица» и другие интересные постановки не оставили
равнодушными пытливых зрителей. Преподаватель ДДТ «Лира»
Спиридонова Аэлита Руслановна (объединение «Шаг на сцену») возглавила
и осуществила постановку театрализованного действия. Обучающиеся
объединений окунулись в мир чтения, творчества, фантазии и
сотрудничества .Запоминающиеся костюмы, декорации и замечательная игра
юных артистов. Всё произвело на детей огромное впечатление!`
        },
        {
          id: 3,
          images: 0,
          name: 'Мой город - чистый город',
          text: `Каждому хочется, чтобы его родной город, его улицы, парки
были чистыми и красивыми, вызывали восхищение, радость. Очень
часто, мы наблюдаем на улицах мусор, бутылки, пакеты и т. д. И все
надеемся, вот придёт добрый волшебник и всё уберет. Нет, этого не
будет, пока мы сами не будем в ответе за это.
Прививать любовь к чистоте и порядку в городе, на улице, около
дома, в парке, везде, где мы есть необходимо с самых ранних лет. Мы с
ребятами нарисовали плакат, призывающий всех жителей
нашего города сохранять чистоту и провели акцию «Чистый
город». Мой город -чистый город
В рамках акции «Мой город - чистый город» 1 ноября 2019 года
преподаватель ДДТ «Лира» Спиридонова А.Р объединение «Шаг на
сцену» вместе с учащимися приняли активное участие по уборке
территории прилегающей к школе искусств №6. Добрая традиция,
объединяющая людей. Ведь известно, что: «Чисто не там где убирают, а
там где не сорят»!`
        },
        {
          id: 4,
          images: 1,
          name: 'День поп-арта (Pop Art Day)',
          text: `Поп-арт — это искусство массовой культуры. Это движение в визуальном
искусстве, характеризующееся чувством оптимизма . Центральное место
в сюжетном репертуаре поп-арта принадлежит всевозможным продуктам
и товарам — от кусков торта до сломанных игрушек. Простые
по композиции и обыденные по сюжету, его натюрморты представляют
товары во всей их соблазнительной̆красоте.
28 января 2020 года преподаватель ДДТ «Лира» Спиридонова А.Р
объединение «Шаг на сцену» провели мастер класс ,посвященный
всемирному дню поп-арта. На примере простейших фигурок, а именно
пирожных, маленьких тортиков (характерное воплощение стиля)
вылепленных их пластилина, дети прикоснулись к популярному
эстетическому направлению.`
        }
      ]
    }
  },
  components: { yandexMap, ymapMarker, gallery: VueGallery },
  computed: {
    c_images() {
      return this.c_n
        ? [...Array(this.c_n.images + 1).keys()].map(i =>
            require(`@/assets/news/${this.c_n.id}/${i + 1}.jpg`)
          )
        : []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$confetti.start({
        canvasId: 'custom-canvas',
        defaultDropRate: 5,
        particlesPerFrame: 0.1
      })
    })
  },
  beforeDestroy() {
    this.$confetti.stop()
    this.$confetti.remove()
  }
}
</script>
